module.exports = __webpack_public_path__ + "static/media/hand_back.fe055a56.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/hand_back.svg
// module id = 471
// module chunks = 0